export const calculateTimeLeft = value => {
  const difference = +new Date(value) - +new Date();
  let timeLeft = {};
  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor(difference / (1000 * 60 * 60) % 24),
      minutes: Math.floor(difference / 1000 / 60 % 60),
      seconds: Math.floor(difference / 1000 % 60)
    };
  }
  return timeLeft;
};
export const adjustDisplayTime = (value, showOnlyDays) => {
  const newTime = calculateTimeLeft(value);
  if (showOnlyDays && newTime.days) {
    return {
      days: newTime.days
    };
  }
  return newTime;
};